<!--  -->
<template>
    <div>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>{{ dataInfo.title }}</el-breadcrumb-item>
      </el-breadcrumb>
      
      <div v-for="(item,index) in typeList" style="display: flex;flex-direction: column;border-color: #59b6ff;margin-bottom: 20px;background-color: #fff;border: 1px solid transparent;border-radius: 4px;box-shadow: 0 1px 1px rgba(0, 0, 0, .05);margin-top: 10px;">
        <div style="color: #fff;
          background-color: #59b6ff;
          border-color: #59b6ff;    padding: 10px 15px;
          border-bottom: 1px solid transparent;
          border-top-left-radius: 3px;
          border-top-right-radius: 3px;">所属栏目：{{item.records[0].typename?item.records[0].typename:item.records[0].type_dictText}}</div>
        <el-table
          :data="item.records"
          style="width: 100%">
          <el-table-column
            label="序号"
            type="index"
            width="50">
          </el-table-column>
          <el-table-column
            label="标题名称">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.title }}</span>
            </template>
          </el-table-column>
          <el-table-column label="内容">
            <template slot-scope="scope">
                <span style="margin-left: 10px;width: 340px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;">{{ getContent(scope.row.content) }}</span>
              <!-- <a :href="getUrl() + scope.row.files" :download="(scope.row.title + fixImage(scope.row.files).slice(fixImage(scope.row.files).lastIndexOf('.')))" style="color: blue;text-decoration: underline;cursor: pointer;" target="_blank">{{ scope.row.title + fixImage(scope.row.files).slice(fixImage(scope.row.files).lastIndexOf('.')) }}</a> -->
              <!-- <span style="color: blue;text-decoration: underline;cursor: pointer;" @click="downloadExcel(scope.row.files)">{{ fixImage(scope.row.files) }}</span> -->
              <!-- <span style="color: blue;text-decoration: underline;cursor: pointer;" @click="downloadExcel(scope.row)">{{ scope.row.title + fixImage(scope.row.files).slice(fixImage(scope.row.files).lastIndexOf('.')) }}</span> -->
            </template>
          </el-table-column>
          <el-table-column label="操作"
            width="240">
            <template slot-scope="scope">
              <!-- <span style="margin-left: 10px">{{ scope.row.type_dictText }}</span> -->
              <button style="color: #59b6ff;background-color: transparent;border: none;" @click="detail(scope.row)">详情</button>
            </template>
          </el-table-column>
        </el-table>
        
        <div class="bottom" style="display: flex;justify-content: center;align-items: center;margin: 20px 0 10px;">
            <el-pagination
                layout="prev, pager, next"
                :total="item.total"
                :current-page="item.pageNo"
                @current-change="jiliangCurrentPage($event,item,index)"
                @prev-click="jiliangShang(item.pageNo,item,index)"
                @next-click="jiliangXia(item.pageNo,item,index)"
                :page-size="pageSize"
            >
            </el-pagination>
        </div>
      </div>
      <el-empty v-if="!typeList || typeList.length == 0" description="暂无数据"></el-empty>
    </div>
  </template>
  
  <script>
  import { Server,httpurl } from "@/server";
  //引入axios插件
  import axios from "axios";
  export default {
    data () {
      return {
        tableData: [{
            date: '2016-05-02',
            name: '王小虎',
            address: '上海市普陀区金沙江路 1518 弄'
          }, {
            date: '2016-05-04',
            name: '王小虎',
            address: '上海市普陀区金沙江路 1517 弄'
          }, {
            date: '2016-05-01',
            name: '王小虎',
            address: '上海市普陀区金沙江路 1519 弄'
          }, {
            date: '2016-05-03',
            name: '王小虎',
            address: '上海市普陀区金沙江路 1516 弄'
          }],
          typeList:[],
          typeNow:-1,

          dataInfo:{},
          pageNo:1,
          pageSize:10
      }
    },
    mounted() {
      this.dataInfo = this.$route.query
      
      this.getLegislation()
    },
    watch: {
        $route: function(to, from) {
            console.log('111' + to.query);
            this.dataInfo = this.$route.query

            this.getLegislation()
        }
    },
    methods: {
      getContent(richText) {
        if (!richText) {
            return '';
        }
        let parser = new DOMParser();
        let doc = parser.parseFromString(richText, 'text/html');
        return doc.body.textContent;
      },
      getUrl() {
        return httpurl + '/sys/common/static/';
      },
      
      jiliangCurrentPage(page,item,index) {
        console.log(page,item);
        this.getMore(page,item,index)
      },
      jiliangXia(page,item,index) {
        console.log(item);
        this.pageNo = page + 1;
      },
      jiliangShang(page,item,index) {
        this.pageNo = page - 1;
      },
      detail(item) {
        this.$router.push({
            path: '/cjContentDetail',
            query:{
              id:item.id,
              // typename:item.typename
            }
        })
      },
      getMore(pages,item,index) {
        var type = item.records[0].type
        Server.getlzcjfwContent2({
          type:type,
          pageNo:pages
        }).then((res) => {
            if (res.code == 200) {
              console.log(this.typeList);
              res.result.pageNo = pages
              this.typeList.splice(index, 1, res.result);
              console.log(this.typeList);
                // this.typeList = res.result
            }
            
            // this.contentList.sort((a, b) => {
            //     return a.releaseTime < b.releaseTime ? -1 : 1
            // })
            // console.log(this.contentList)
        });
      },
      getLegislation() {
        this.typeList = []
        Server.getlzcjfwContent1({
          titleType:this.dataInfo.id,
        }).then((res) => {
            if (res.code == 200) {
                this.typeList = res.result
                this.typeList.forEach(item => {
                  item.pageNo = 1
                })
            }
            
            // this.contentList.sort((a, b) => {
            //     return a.releaseTime < b.releaseTime ? -1 : 1
            // })
            // console.log(this.contentList)
        });
      },
  
      fixImage (file) {
        var arr = file.split("/"); // 使用逗号分割字符串
        var lastElement = arr.slice(-1)[0]; // 取得最后一个元素
        return lastElement
      },
  
      async downloadExcel (fileName) {
          var fileUrl = this.getUrl()
          var fileLastName = fileName.title + this.fixImage(fileName.files).slice(this.fixImage(fileName.files).lastIndexOf('.'))

          const x = new window.XMLHttpRequest();
          console.log(fileUrl + fileName.files);
          
            x.open('GET', fileUrl + fileName.files, true);
            x.responseType = 'blob';
            x.onload = () => {
                const url = window.URL.createObjectURL(x.response);
                const a = document.createElement('a');
                a.href = url;
                a.download = fileLastName;
                a.click();
            };
            x.send();
      }
    }
  }
  </script>
  
  <style  scoped lang="less">
    ::v-deep .cell {
      text-align: center;
    }
  </style>
  